<template>
      <VNavigationDrawer
        v-model="open"
        absolute
        temporary
        :stateless="!drawer"
      >
        <VList class="pa-1">
          <VListTile avatar>
            <!--<VListTileAvatar>
              <img src="https://randomuser.me/api/portraits/men/85.jpg">
            </VListTileAvatar>-->

            <VListTileContent>
              <VListTileTitle v-if="this.$store.getters.sessaoAgendamentoOnline.autenticado"> {{ "Olá, " + this.$store.getters.sessaoAgendamentoOnline.sessao.nome }}</VListTileTitle>
              <VListTileTitle v-else>Bem-vindo :)</VListTileTitle>
            </VListTileContent>
          </VListTile>
        </VList>

        <VList class="pt-0" dense>
          <v-divider></v-divider>

          <VListTile
            v-for="item in menusPermitidos()"
            :key="item.title"
            @click="acessarRota(item)"
          >
            <VListTileAction :to="item.route">
              <VIcon>{{ item.icon }}</VIcon>
            </VListTileAction>

            <VListTileContent>
              <VListTileTitle>{{ item.title }}</VListTileTitle>
            </VListTileContent>
          </VListTile>
        </VList>

      </VNavigationDrawer>
</template>
<script>
import * as mutations from "@/plugins/mutations.nomes";

export default {
  props: {
    drawer: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      items: [
        { title: 'Inicio', icon: 'home', route: 'Home' },
        { title: 'Inicio', icon: 'home', route: 'Home', exigeLogin: true },
        { title: 'Entrar', icon: 'login', route: 'Login' },
        { title: 'Agendar', icon: 'event', route: 'Agendamento' },
        { title: 'Agendar', icon: 'event', route: 'Agendamento', exigeLogin: true },
        { title: 'Meus agendamentos', icon: 'calendar_month', route: 'MeusAgendamentos', exigeLogin: true },
        { title: 'Sair', icon: 'logout', route: 'Login', action: 'logout', exigeLogin: true },
      ]
    }
  },

  computed:{
    open: {
      get () {
        return this.drawer;
      },
      set (value) {
        this.$emit('drawer:update', value);
      }
    }
  },

  methods: {
    menusPermitidos(){
      return this.$store.getters.sessaoAgendamentoOnline.autenticado ? this.items.filter(i => i.exigeLogin) : this.items.filter(i => !i.exigeLogin);
    },
    acessarRota(item) {
      if(this.$router.history.current.name != `${this.$store.getters.autenticacaoMicrovixAgendamentoOnline.alias}${item.route}`)
        this.$router.push({name: `${this.$store.getters.autenticacaoMicrovixAgendamentoOnline.alias}${item.route}`});
      if(item.action)
        this[item.action]();
    },
    logout() {
      this.$store.commit(mutations.LOGOUT_AGENDAMENTO_ONLINE);
    },
  }
}
</script>
